module.exports = __webpack_public_path__ + "img/bicycle-parked-moved.c55d7da7.jpg";